import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

function Navbar() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path
      ? "text-piano-black font-medium"
      : "text-piano-black/70";
  };

  return (
    <nav className="bg-ivory border-b border-piano-black/10">
      <div className="container mx-auto px-4 py-6">
        <div className="flex justify-between items-center">
          <Link to="/" className="font-serif text-2xl font-bold">
            Flavia Karla
          </Link>

          {/* Hamburger button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Desktop menu */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className={`nav-link ${isActive("/")}`}>
              Home
            </Link>
            <Link to="/about" className={`nav-link ${isActive("/about")}`}>
              About
            </Link>
            <Link
              to="/performances"
              className={`nav-link ${isActive("/performances")}`}
            >
              Performances
            </Link>
            <Link
              to="/repertoire"
              className={`nav-link ${isActive("/repertoire")}`}
            >
              Repertoire
            </Link>
            <Link to="/contact" className={`nav-link ${isActive("/contact")}`}>
              Contact
            </Link>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`${isMenuOpen ? "block" : "hidden"} md:hidden mt-4`}>
          <div className="flex flex-col space-y-4 py-4">
            <Link
              to="/"
              className={`nav-link text-center py-2 ${isActive("/")}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`nav-link text-center py-2 ${isActive("/about")}`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/performances"
              className={`nav-link text-center py-2 ${isActive(
                "/performances"
              )}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Performances
            </Link>
            <Link
              to="/repertoire"
              className={`nav-link text-center py-2 ${isActive("/repertoire")}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Repertoire
            </Link>
            <Link
              to="/contact"
              className={`nav-link text-center py-2 ${isActive("/contact")}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
